<template>
  <div class="aarrow_box mt-5">
    <v-card-text>
    <span>
      <h5 class="accent--text" style="font-size: 12px; font-weight: 700">
        {{heading}}
      </h5>
      <v-layout>
            <v-flex xs3>
            </v-flex>
            <v-spacer>
            </v-spacer>
            <v-flex xs3>
              <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
            </v-flex>
          </v-layout>
      <br/>
      <!-- <div>
      <label for="pageSize">Items per Page:</label>
      <select v-model="itemsPerPage" @change="changePageSize" class="text-red">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>

      </select>
    </div> -->
  </span>
    <table class="table table-responsive">
      <thead class="thead">
          <tr>
            <th scope="col">Grower Code</th>
            <th scope="col">Grower Name</th>
<!--            <th scope="col">Organisation Status</th>-->
<!--            <th scope="col">Organisation Email</th>-->
<!--            <th scope="col">Non-checkoff Bank Account</th>-->
<!--            <th scope="col">Non-checkoff Account Name</th>-->
<!--            <th scope="col">Checkoff Account</th>-->
<!--            <th scope="col">Checkoff Account Name</th>-->
<!--            <th scope="col">Checkoff Bank Name</th>-->
<!--            <th scope="col">Checkoff Currency</th>-->
          </tr>
        </thead>
      <tbody>
        <tr v-for="row in paginatedData" :key="row.organisationCode">
           <td>{{ row.organisationCode }}</td>
           <td>{{ row.organisationName }}</td>
<!--            <td>{{ row.status.statusName }}</td>-->
<!--            <td>{{ row.outgoingEmail }}</td>-->
<!--            <td>{{ row.nonCheckoffAccount }}</td>-->
<!--            <td>{{ row.nonCheckoffAccountName }}</td>-->
<!--            <td>{{ row.checkoffaccount }}</td>-->
<!--            <td>{{ row.checkoffaccountName }}</td>-->
<!--            <td>{{ row.checkoffBankName }}</td>-->
<!--            <td>{{ row.checkoffBankCurrency }}</td>-->
            </tr>
      </tbody>
    </table>
    </v-card-text>
    <div>
      <v-btn @click="prevPage" :disabled="currentPage === 1" > {{ prev }}  Previous</v-btn>
      <span class="ml-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <v-btn @click="nextPage" :disabled="currentPage === totalPages"><span class="ml-2">Next </span> {{ next }}</v-btn>
    </div>
  </div>
  </template>
<script>
import axios from 'axios'
import config from '../../../config'
import * as XLSX from 'xlsx'

export default {
	name: 'WithoutPayDetailsData',
	data: function () {
		return {
			items: [],
			paginatedFiles: [],
			numberOfLinks: 0,
			page: 1,
			prev: '<<',
			next: '>>',
			paymentDetails: [],
			currentPage: 1,
			itemsPerPage: 7,
			totalItems: 1,
			heading: ''
		}
	},

	computed: {
		totalPages () {
			return Math.ceil(this.totalItems / this.itemsPerPage)
		},
		paginatedData () {
			const startIndex = (this.currentPage - 1) * this.itemsPerPage
			const endIndex = startIndex + this.itemsPerPage
			return this.paymentDetails.slice(startIndex, endIndex)
		}
	},

	mounted () {
		console.log(this.segmentSelected)
		this.getGrowerPayStatusDetails(this.segmentSelected)
	},
	props: {
		segmentSelected: {
			type: String, // Adjust the type based on the actual type of the value you want to pass
			default: null
		}
	},
	// watch: {
	//   items: function () {
	//     this.paginatedFiles = this.paginationMethod(this.items, 1, this.numberOfItemsPerPage)
	//     this.numberOfLinks = Math.ceil(this.items.length / this.numberOfItemsPerPage)
	//   },
	//   page: function (val) {
	//     this.paginatedFiles = this.paginationMethod(this.items, val, this.numberOfItemsPerPage)
	//   }
	// },
	methods: {
		getDataFromApi () {
			this.loading = true
			return new Promise((resolve, reject) => {
				const items = this.getAuctionFiles()
				const total = items.length
				setTimeout(() => {
					this.loading = false
					resolve({
						items,
						total
					})
				}, 1000)
			})
		},
		prevPage () {
			if (this.currentPage > 1) {
				this.currentPage--
			}
		},
		nextPage () {
			if (this.currentPage < this.totalPages) {
				this.currentPage++
			}
		},
		changePageSize () {
			this.currentPage = 1 // Reset to the first page when changing page size
			this.loadData()
		},
		getAuctionFiles () {
			var url = config.serverURI + '/upload/auction/getAll'
			axios.get(url)
				.then(response => {
					this.items = response.data
					this.$emit('updateAuctionFilesCount', this.items.length)
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.items
		},
		getGrowerPayStatusDetails (eventType) {
			const token = localStorage.getItem('token')
			const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			const id = 1
			const withDet = config.serverURI + '/reports/findAllGrowersWithSettlementDetails'
			const withoutDet =
        config.serverURI + '/reports/findAllGrowersWithoutSettlementDetails'
			const pendingApprov = config.serverURI + '/reports/findAllGrowersWithSettlementDetailsByStatus'

			const withSettlementDetails = axios.post(withDet, { tokenconfig })
			const withoutSettlementDetails = axios.post(withoutDet, { tokenconfig })
			const pendingApproval = axios.post(pendingApprov, { id, tokenconfig })

			axios
				.all([withSettlementDetails, withoutSettlementDetails, pendingApproval])
				.then(
					axios.spread((...responses) => {
						const responsewithDet = responses[0]
						const responsewithoutDet = responses[1]
						const responespendingApprov = responses[2]
						let arrWithdet = []
						let arrWithoutdet = []
						let arrPendApp = []

						if ((eventType === 'WITHDETAILS') && (eventType !== 'WITHOUTDETAILS') && (eventType !== 'PENDINGAPPROVAL')) {
							arrWithdet = responsewithDet.data
							this.totalItems = parseInt(Object.keys(responsewithDet.data).length)
							this.paymentDetails = arrWithdet
							this.heading = 'Growers with Settlement Details Report'
							return arrWithdet
						} else if ((eventType !== 'WITHDETAILS') && (eventType === 'WITHOUTDETAILS') && (eventType !== 'PENDINGAPPROVAL')) {
							arrWithoutdet = responsewithoutDet.data
							this.totalItems = parseInt(Object.keys(responsewithoutDet.data).length)
							this.paymentDetails = arrWithoutdet
							this.heading = 'Growers without Settlement Details Report'
							return arrWithoutdet
						} else if ((eventType !== 'WITHDETAILS') && (eventType !== 'WITHOUTDETAILS') && (eventType === 'PENDINGAPPROVAL')) {
							arrPendApp = responespendingApprov.data
							this.totalItems = parseInt(Object.keys(responespendingApprov.data).length)
							this.paymentDetails = arrPendApp
							this.heading = 'Growers Pending Approval Report'
							return arrPendApp
						}
					})
				)
				.catch((errors) => {
					console.log(errors)
				})
		},
		exportToExcel () {
			const exportData = this.paymentDetails.map(transaction => ({
				'Grower Code': transaction.organisationCode,
				'Grower Name': transaction.organisationName
				// 'Organisation Status': transaction.status.statusName,
				// 'Organisation Email': transaction.outgoingEmail,
				// 'Non-checkoff Bank Account': transaction.nonCheckoffAccount,
				// 'Non-checkoff Account Name': transaction.nonCheckoffAccountName,
				// 'Checkoff Account': transaction.checkoffaccount,
				// 'Checkoff Account Name': transaction.checkoffaccountName,
				// 'Checkoff Bank Name': transaction.checkoffBankName,
				// 'Checkoff Currency': transaction.checkoffBankCurrency
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'Grower Settlement Details')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'grower_settlement_details_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		}
	}
}
</script>
  <style>
  .aarrow_box {
    position: relative;
    background: #fff;
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .aarrow_box:after, .aarrow_box:before {
    bottom: 100%;
    left: 60%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .aarrow_box:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #fff;
    border-width: 20px;
    margin-left: -20px;
  }
  .aarrow_box:before {
    border-color: rgba(112, 112, 112, 0);
    border-bottom-color: #707070;
    border-width: 21px;
    margin-left: -21px;
  }
  </style>
